<template>
  <v-card class="add-coupon-group" height="60vh">
    <v-card-title>{{ $t('admin_acc_coupon_group.add_coupon_title') }}</v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-form ref="form">
          <DatePickerInput :label="$t('admin_acc_coupon.valid_until')"
                           v-model="coupon.valid_until"
                           :rules="requiredRules"></DatePickerInput>
          <v-text-field outlined
                        :label="$t('admin_acc_coupon.amount')"
                        v-model="coupon.amount"
                        :rules="requiredRules"
                        prefix="$"
                        type="number"
                        min="1"
                        step="1"></v-text-field>
          <v-text-field outlined
                        :label="$t('admin_acc_coupon.quantity')"
                        v-model="coupon.quantity"
                        :rules="requiredRules"
                        type="number"
                        min="1"
                        step="1"></v-text-field>
          <v-select outlined
                    :items="couponTypeOptions"
                    :label="$t('admin_acc_discount_code.type')"
                    v-model="coupon.type"
                    :rules="requiredRules"></v-select>
          <v-select outlined
                    v-if="coupon.type === 'FACILITY'"
                    :label="$t('admin_acc_discount_code.item_type')"
                    :items="facilityTypeOptions"
                    v-model="coupon.item_type_id"
                    :rules="requiredRules"></v-select>
          <v-select outlined
                    v-if="coupon.type === 'GYM_PASS'"
                    :label="$t('admin_acc_discount_code.gym_pass_type')"
                    :items="subscriptionTypeOptions"
                    v-model="coupon.gym_pass_type_id"
                    :rules="requiredRules"></v-select>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit')">
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && submit()">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import DatePickerInput from "@/components/DatePickerInput.vue";

export default {
  name: 'CreateCouponModal',
  components: {DatePickerInput},
  props: {
    couponGroupId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const coupon = ref({
      valid_until: null,
      amount: null,
      quantity: null,
      type: null,
      item_type_id: null,
      gym_pass_type_id: null,
    })
    const couponTypeOptions = ref([
      {text: root.$t('admin_acc_coupon.type_FACILITY'), value: 'FACILITY'},
      {text: root.$t('admin_acc_coupon.type_GYM_PASS'), value: 'GYM_PASS'},
      // {text: root.$t('admin_acc_coupon.type_MEMBERSHIP'), value: 'MEMBERSHIP'},
    ]);

    // FACILITY
    const facilityTypes = ref([]);
    const facilityTypeOptions = computed(() => {
      return facilityTypes.value.map((t) => {
        return {text: t.name, value: t.id}
      })
    });
    const getFacilityTypes = function () {
      root.$callAPI('room/item_type/', {}, function (response) {
        facilityTypes.value = _.filter(response.body.item_types, 'open_for_booking');
      });
    }

    // GYM_PASS
    const subscriptionTypes = ref([]);
    const subscriptionTypeOptions = computed(() => {
      return subscriptionTypes.value.map((t) => {
        return {text: t.name, value: t.id};
      })
    })
    const getSubscriptionTypes = function () {
      root.$callAPI('aafb/gym_subscription/types/', {}, function (response) {
        subscriptionTypes.value = _.sortBy(response.body.subscription_types, 'price');
      });
    }

    onMounted(() => {
      getFacilityTypes();
      getSubscriptionTypes();
    })

    const submit = function () {
      root.$callAPI('aafb/admin/coupon_group/create_coupons/', {
        coupon_group_id: props.couponGroupId,
        ...coupon.value,
      }, function (response) {
        emit('submit', true);
      })
    }

    return {
      requiredRules,
      coupon,
      couponTypeOptions,
      facilityTypeOptions,
      subscriptionTypeOptions,

      submit
    }
  }
}
</script>

<style lang="less">
.add-coupon-group {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }
}


</style>
